.styledSelect {
    background-color: var(--mantine-color-dark-5);
}
